module.exports = __webpack_public_path__ + "static/img/200294.603f509a.png";